import { render, staticRenderFns } from "./custEle.vue?vue&type=template&id=52139735&scoped=true&"
import script from "./custEle.vue?vue&type=script&lang=js&"
export * from "./custEle.vue?vue&type=script&lang=js&"
import style0 from "./custEle.vue?vue&type=style&index=0&id=52139735&prod&scoped=true&lang=css&"
import style1 from "./custEle.vue?vue&type=style&index=1&id=52139735&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52139735",
  null
  
)

export default component.exports